import { render, staticRenderFns } from "./IndividualRegister.vue?vue&type=template&id=5ac1ec42"
import script from "./IndividualRegister.vue?vue&type=script&lang=js"
export * from "./IndividualRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports